import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vuex from 'vuex';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import {flags} from './config/featureFlags';

import dashboard from './store/modules/dashboard';
import trainer from './store/modules/trainer';
import user from './store/modules/user';
import city from './store/modules/city';
import pokemon from './store/modules/pokemon';
import journey from './store/modules/journey';
import changelog from './store/modules/changelog';
import './assets/styles/main.sass';
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// NODE_ENV guard je uvnitr registerServiceWorker.js - tady se jen importuje
// nepodmineně, presne jako generuje "vue add pwa".
import './registerServiceWorker'
import {isRunningAsInstalledApp, prefetchAllAssets, prefetchImageAssets, prefetchMusicAssets} from './utils/offlineAssets';
import {toastError} from './utils/toast';
import {logFrontendError} from './utils/errorLog';

// V NAINSTALOVANE appce (standalone rezim) se na pozadi predstahnou vsechny
// obrazky/hudba (~500 MB), aby appka fungovala offline. Zpozdeni 3s, at
// nesoutezi o sirku pasma s prvotnim nactenim appky.
//
// V BEZNE karte prohlizece se to VYCHOZI nespousti (obrazky se cachujou jen
// prubezne, jak je hrac potka, viz vue.config.js runtimeCaching) - hrac si
// to muze zapnout sam na strance Options, zvlast pro obrazky/hudbu (viz
// config/featureFlags.js). Tenhle blok resi jen chovani PRI STARTU appky,
// kdyz uz je flag z minula zapnuty.
if (process.env.NODE_ENV === 'production') {
  if (isRunningAsInstalledApp()) {
    setTimeout(() => {
      prefetchAllAssets();
    }, 3000);
  } else {
    setTimeout(() => {
      if (flags.prefetchImages) {
        prefetchImageAssets();
      }
      if (flags.prefetchMusic) {
        prefetchMusicAssets();
      }
    }, 3000);
  }
}

Vue.use(Vuex);

Vue.config.productionTip = false

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true
});

// Globální safety-net pro chyby, které nikdo jinde neodchytil. Záměrně
// NEpřekládá skutečný text chyby (na rozdíl od utils/errorMessages.js
// použitého ve fetch.js pro API odpovědi) - sem se dostávají i syrové JS
// pády, jejichž text by uživateli nic neřekl.
// logFrontendError je sdílená (utils/errorLog.js) - stejnou funkci volají i
// odchycené chyby z journey API akcí (store/modules/journey/actions.js).

Vue.config.errorHandler = (err, vm, info) => {
  console.error('[Vue errorHandler]', err, info);
  toastError(i18n.t('common.genericError'));
  logFrontendError(err && err.message ? err.message : err, err && err.stack);
};

window.addEventListener('unhandledrejection', (event) => {
  console.error('[unhandledrejection]', event.reason);
  toastError(i18n.t('common.genericError'));
  logFrontendError(
    event.reason && event.reason.message ? event.reason.message : event.reason,
    event.reason && event.reason.stack
  );
  event.preventDefault();
});

const store = new Vuex.Store({
  modules: {
    dashboard,
    trainer,
    user,
    journey,
    pokemon,
    city,
    changelog,
  },
});

// newVhFix: misto CSS "100svh"/"100dvh" (na Androidu nespolehlive, viz
// featureFlags.js komentar) se skutecna viditelna vyska zmeri primo v JS
// pres window.visualViewport a zapise se do CSS custom property, na kterou
// se napoji .new-shell-ui shell v App.vue (jen kdyz je "vh-fix" trida pritomna).
//
// VH_SAFETY_MARGIN_PX: battle-layout je navrzeny bez rezervy (BattleLayout.vue
// .battle-layout overflow:hidden, akcni lista konci presne na spodni hrane
// obrazovky) - kdyz telefon (MIUI/Xiaomi) reportuje visualViewport.height o
// par desitek px vic, nez je skutecne videt, uriznou se spodni tlacitka.
// Na Wild/City to nevadi (jde scrollovat), na battle/obstacle (zadny scroll)
// ano - proto odecist bezpecnostni rezervu uz tady, vysoko ve stromu.
const VH_SAFETY_MARGIN_PX = 32;

if (flags.newVhFix) {
  const setAppVh = () => {
    const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.documentElement.style.setProperty('--app-vh', (vh - VH_SAFETY_MARGIN_PX) + 'px');
  };
  setAppVh();
  (window.visualViewport || window).addEventListener('resize', setAppVh);
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

